<div class="google-maps-polygon-editor">
  <div class="map-container" [style.height]="height()" [style.width]="width()">
    <google-map [options]="mapOptions()" [center]="initialCenterLatLng()"></google-map>

    @if (enableDrawing() && googleMap()) {
      <div class="map-toolbar">
        <button
          class="toolbar-button"
          type="button"
          [class.active]="!isDrawingMode()"
          (click)="setSelectMode($event)"
        >
          <i class="pi pi-arrow-up-right"></i>
          <span>Select</span>
        </button>
        <button
          class="toolbar-button"
          type="button"
          [class.active]="isDrawingMode()"
          (click)="toggleDrawingMode($event)"
        >
          <i class="pi pi-pencil"></i>
          <span>Draw</span>
        </button>
      </div>
    }
  </div>
</div>
